"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@21st-night/core");
var core_2 = require("@material-ui/core");
var DeckImportFromCsv_1 = __importDefault(require("../DeckImportFromCsv"));
var Button_1 = __importDefault(require("../../Button"));
var DeckImportFromCsvContainer = function (_a) {
    var loading = _a.loading, onCancel = _a.onCancel, onSubmit = _a.onSubmit, open = _a.open, other = __rest(_a, ["loading", "onCancel", "onSubmit", "open"]);
    var _b = __read(react_1.useState(null), 2), file = _b[0], setFile = _b[1];
    var _c = core_1.useForm({
        columnSeparator: ',',
        text: '',
        file: '',
    }), values = _c.values, onFieldChange = _c.onFieldChange, clear = _c.clear;
    react_1.useEffect(function () {
        if (!open) {
            setFile(null);
            clear();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);
    var handleSubmit = react_1.useCallback(function () {
        onSubmit(values.text, file, values.columnSeparator);
    }, [file, onSubmit, values.columnSeparator, values.text]);
    var handleFileChange = react_1.useCallback(function (event) {
        if (event.target && event.target.files && event.target.files[0]) {
            setFile(event.target.files[0]);
        }
    }, []);
    return (react_1.default.createElement(core_2.Dialog, __assign({ fullWidth: true, maxWidth: "xs", open: open }, other),
        react_1.default.createElement(core_2.DialogTitle, null, "Import from CSV"),
        react_1.default.createElement(core_2.DialogContent, null,
            react_1.default.createElement(DeckImportFromCsv_1.default, { onFieldChange: onFieldChange, values: values, onFileChange: handleFileChange, filename: file && file.name })),
        react_1.default.createElement(core_2.DialogActions, null,
            react_1.default.createElement(Button_1.default, { onClick: onCancel }, "Cancel"),
            react_1.default.createElement(Button_1.default, { variant: "contained", color: "primary", onClick: handleSubmit, disabled: loading }, loading ? 'Importing...' : 'Import'))));
};
exports.default = DeckImportFromCsvContainer;
//# sourceMappingURL=DeckImportFromCsvContainer.js.map